import PropTypes from 'prop-types';
import React from 'react';

import Velocity from 'velocity-animate';

import classnames from 'classnames';

import Store from '@app/store';

import MobileSubnav from '@component/navigation/mobilesubnav';

export default class MobileItem extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    items: PropTypes.array,
    onClick: PropTypes.func,
    onItemClick: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    image: PropTypes.string,
    showSubNav: PropTypes.bool,
    animateSubNav: PropTypes.bool,
    path: PropTypes.string,
    component: PropTypes.any,
    options: PropTypes.object,
  };

  componentDidUpdate() {
    if (this.props.showSubNav === true) {
      this.showSubNavPointer();
      this.showSubNav(this.props.animateSubNav);
    } else {
      this.hideSubNavPointer();
      this.hideSubNav(this.props.animateSubNav);
    }
  }

  showSubNav(animate = false) {
    const subNav = this.node.querySelector('.nav__subitems-container');
    if (subNav && subNav.style.display !== 'block') {
      if (animate) {
        Velocity(subNav, 'slideDown', {
          duration: 150,
          easing: [0.77, 0.0, 0.175, 1.0],
        });
      } else {
        subNav.style.display = 'block';
      }
    }
  }

  hideSubNav(animate = false) {
    const subNav = this.node.querySelector('.nav__subitems-container');
    if (subNav && subNav.style.display === 'block') {
      if (animate) {
        Velocity(subNav, 'slideUp', { duration: 100, easing: 'ease-out' });
      } else {
        subNav.style.display = 'none';
      }
    }
  }

  getPointer() {
    return this.node.querySelector('.nav__subitems-container .pointer');
  }

  showSubNavPointer() {
    if (!this.getPointer()) {
      return;
    }

    Velocity(this.getPointer(), { top: -6 }, { duration: 80 });
  }

  hideSubNavPointer() {
    if (!this.getPointer()) {
      return;
    }

    Velocity(this.getPointer(), { top: 0 }, { duration: 50 });
  }

  render() {
    const { route } = Store.getState();

    const className = this.props.className || 'nav__item';
    const navTextClassName = classnames('nav__text', {
      'nav__text--home': route.path === '/',
      'nav__text--plus': route.path === '/pro',
    });

    let subNav = null;
    // if there are items, make a subnav
    if (this.props.items && this.props.items.length > 0) {
      const subNavItems = [];
      this.props.items.forEach((item) => {
        const className = ['nav__subitem'];
        if (item.path === route.path) {
          className.push('nav__subitem--is-active');
        }

        subNavItems.push(
          <MobileItem
            {...item}
            key={`mobile-item-${item.path.replace('/', '')}`}
            onItemClick={this.props.onItemClick}
            className={className.join(' ')}
          />
        );
      });

      subNav = <MobileSubnav>{subNavItems}</MobileSubnav>;
    }

    // if there's a label
    let label = null;
    if (this.props.name) {
      label = <span className={navTextClassName}>{this.props.name}</span>;
    }

    // if there's an image
    let image = null;
    if (this.props.image) {
      image = <img className="nav__image" src={this.props.image} />;
    }

    // if there's a component (mostly an Icon tho)
    let component = null;
    if (this.props.component) {
      const CustomComponentTag = this.props.component;
      component = <CustomComponentTag {...this.props.options} />;
    }

    let onClick = null;
    if (this.props.items && this.props.items.length > 0) {
      onClick = this.props.onClick;
    } else {
      onClick = (e) => {
        e.preventDefault();
        this.props.onItemClick(this.props.path);
      };
    }

    return (
      <li
        ref={(node) => (this.node = node)}
        className={className}
        onClick={onClick}
      >
        {label}
        {component}
        {image}
        {subNav}
      </li>
    );
  }
}
